import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { Dropdown, Form, Input, Menu, Space, Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { ParkingListItems, ParkingLists } from "services/interface";
import { formatDateWithTime } from "utils/dateFormat";
// import { useGetOrderDetail } from "hooks/useOrders";
import { useAppDispatch, useAppSelector } from "../../../store";
import { useNavigate } from "react-router-dom";
import { EllipsisOutlined, SearchOutlined } from "@ant-design/icons";
import ModalParkingTime from "./ModalParkingTime";
import {
  useGetMasterDistrict,
  useGetMasterProvince,
} from "hooks/useMasterData";
import { Diversity1Rounded } from "@mui/icons-material";

interface OrderTableListProps {
  // data?: GetDataOrderListData;
  // IsHiddenPersonInfo?: boolean;
  // refetchData: () => void;
  // childrenBank: React.ReactNode[];
  data: ParkingLists[] | undefined;
  // id: string;
  onDeleteData: (id: string) => void;
  onEditData: (id: string) => void;
}

const OrderTableList: FC<OrderTableListProps> = ({
  // id,
  data,
  onDeleteData,
  onEditData,
}) => {
  const navigate = useNavigate();
  const tabsKey = 3;
  const dispatch = useAppDispatch();
  const offset = useAppSelector((state) => state.order.dataComplete.offset);
  const limit = useAppSelector((state) => state.order.dataComplete.limit);
  // const [showDetail, setShowDetail] = useState(false);
  // const [modalData, setModalData] = useState<GetOrderDetailData>();
  // const { mutate } = useGetOrderDetail();
  const [currentPage, setCurrentPage] = useState(1);

  const [showParkingTime, setShowParkingTime] = useState(false);

  const [parkingListItems, setParkingListItems] = useState<ParkingListItems>();

  const { data: masterProviceData } = useGetMasterProvince();

  const [searchText, setSearchText] = useState<string>("");

  const getTimeList = (times: string | null) => {
    const time = times?.replace("[", "").replace("]", "").split(",");
    console.log(time);
    return time;
  };

  useEffect(() => {
    setCurrentPage(Math.floor(offset / limit) + 1);
  }, [offset, limit]);

  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const filteredData = data?.filter((item) => {
    return item.parking_name.includes(searchText);
  });

  const columns: ColumnsType<ParkingLists> = [
    {
      title: "ลำดับ",
      dataIndex: "index",
      align: "center",
      key: "index",
      render: (text, record, index) => index + 1,
      width: 50,
    },
    {
      title: "จังหวัดปลายทาง",
      dataIndex: "province_name_th",
      render: (_text) => {
        return (
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
            }}
            type="secondary"
          >
            {_text}
          </Typography.Link>
        );
      },
    },
    {
      title: "อำเภอปลายทาง",
      dataIndex: "district_name_th",
      render: (text, record) => {
        return <Typography>{record.district_name_th}</Typography>;
      },
    },
    {
      title: "ชื่อจุดจอด",
      dataIndex: "parking_name",
      render: (_text) => {
        return (
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
            }}
            type="secondary"
          >
            {_text}
          </Typography.Link>
        );
      },
    },
    {
      title: "เวลาถึง",
      dataIndex: "name",
      width: 400,
      render: (_text, record) => {
        return (
          <div>
            {getTimeList(record.times)?.map((item, index) => (
              <Typography.Text>{item} </Typography.Text>
            ))}
          </div>
        );
      },
    },
    {
      title: "ตัวเลือก",
      align: "center",
      fixed: "right",
      width: 100,
      render: (_text, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Space size="middle">
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="1"
                    onClick={() => {
                      onEditData(record.parking_id);
                    }}
                  >
                    แก้ไข
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    onClick={() => {
                      onDeleteData(record.parking_id);
                    }}
                  >
                    ลบ
                  </Menu.Item>
                </Menu>
              }
            >
              <div>
                <EllipsisOutlined />
              </div>
            </Dropdown>
          </Space>
        </div>
      ),
    },
  ];

  // let filtersColumns: (
  //   | ColumnGroupType<GetDataOrderListItems>
  //   | ColumnType<GetDataOrderListItems>
  // )[] = columns;
  // if (IsHiddenPersonInfo) {
  //   filtersColumns = columns.filter(
  //     (column) => column.key !== "ref_name" && column.key !== "ref_telephone"
  //   );
  // }

  // Search Function
  // const onSearch = (value: string) => {

  return (
    <div>
      <Form onFinish={() => {}} layout="inline">
        <Form.Item name="search" style={{ marginBottom: 0 }}>
          <Input
            placeholder="ค้นหาจุดจอด"
            prefix={<SearchOutlined />}
            style={{ width: 300 }}
            size="small"
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Form.Item>
      </Form>
      <div
        style={{
          marginBottom: 10,
        }}
      ></div>
      <Table
        rowKey="order_id"
        size="small"
        columns={columns}
        dataSource={filteredData}
        scroll={{ x: true }}
      />
      {/* <Modal
        title="แก้ไขรายการจุดส่ง"
        open={showDetail}
        maskClosable={false}
        onCancel={()=> {
          setShowDetail(false);
        }}
        style={{ top: 20 }}
        footer={[
          <Button key="back" >
            ยกเลิก
          </Button>,
          <Button key="submit" type="primary" >
            บันทึกการแก้ไข
          </Button>
        ]}
      >
      </Modal> */}
      <ModalParkingTime
        show={showParkingTime}
        onClose={() => {
          setShowParkingTime(false);
        }}
        parkingListItems={parkingListItems}
      />
    </div>
  );
};

export default OrderTableList;
